import script from "./QuestionCheckBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionCheckBox.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionCheckBox.vue?vue&type=style&index=0&id=3156fb9b&lang=scss"

const __exports__ = script;

export default __exports__